__turbopack_context__.v({
  "className": "dewiexpanded_7825a0f9-module__GW6o2W__className",
  "variable": "dewiexpanded_7825a0f9-module__GW6o2W__variable",
});
